import React from 'react';
const bonuses = [{
  num: 'BONUS 1',
  icon: '🌙',
  title: 'GOLDEN NIGHTS',
  description: 'The exact system for your baby to sleep 8 hours straight. Proven month-by-month routines.',
  oldPrice: '$57',
  newPrice: '✅ FREE'
}, {
  num: 'BONUS 2',
  icon: '🧠',
  title: 'LITTLE GENIUS',
  description: "52 scientific micro-activities to skyrocket your baby's IQ. Just 5 minutes a day.",
  oldPrice: '$37',
  newPrice: '✅ FREE'
}, {
  num: 'BONUS 3',
  icon: '📅',
  title: 'YOUR BABY MONTH BY MONTH',
  description: 'The complete map of milestones, alerts, and developmental windows. Never guess again.',
  oldPrice: '$27',
  newPrice: '✅ FREE'
}, {
  num: 'BONUS 4',
  icon: '💰',
  title: 'SAVE $2000 IN THEIR FIRST YEAR',
  description: 'The definitive list of what NOT to buy and why. Save thousands in the first year.',
  oldPrice: '$17',
  newPrice: '✅ FREE'
}];
export function BonusesSection() {
  return <section id="bonuses" className="bg-white py-16 px-5" data-id="element-24">
      <div className="max-w-[900px] mx-auto" data-id="element-25">
        <div className="text-center mb-2.5" data-id="element-26">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-27">
            Included Free Today
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-4 leading-tight text-center" data-id="element-28">
          Your 4 Exclusive Bonuses
        </h2>

        <p className="text-lg text-[#6B4C3B] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-29">
          Valued at $138. Yours completely free when you acquire the protocol
          today.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-2.5" data-id="element-30">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-gradient-to-br from-[#FAF7F2] to-[#F0E8DE] rounded-2xl p-6 border-2 border-transparent transition-all hover:border-[rgba(183,110,121,0.3)] hover:-translate-y-1 hover:shadow-xl text-center relative overflow-hidden before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-[#B76E79] before:to-[#C9A96E]" data-id="element-31">
              <span className="inline-block bg-gradient-to-r from-[#B76E79] to-[#8B4A52] text-white text-[11px] font-bold px-3 py-1 rounded-full mb-4 font-sans tracking-wide" data-id="element-32">
                {bonus.num}
              </span>
              <div className="text-5xl mb-3.5" data-id="element-33">{bonus.icon}</div>
              <h3 className="text-xl text-[#3D2B1F] mb-2 font-bold" data-id="element-34">
                {bonus.title}
              </h3>
              <p className="text-sm text-[#6B4C3B] font-sans leading-relaxed mb-3.5" data-id="element-35">
                {bonus.description}
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-36">
                <span className="text-sm text-gray-400 line-through font-sans" data-id="element-37">
                  {bonus.oldPrice}
                </span>
                <span className="text-base font-bold text-green-700 font-sans" data-id="element-38">
                  {bonus.newPrice}
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}